import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { toast } from 'ngx-sonner';

export enum RESPONSE_TYPE {
  ERROR = 'Error',
  SUCCESS = 'Success',
  WARNING = 'Warning',
  INFO = 'Info',
}

export const handleResponseMessage = () => {
  return (message: string, responseType: RESPONSE_TYPE) => {
    const config = {
      dismissible: true,
    };
    switch (responseType) {
      case RESPONSE_TYPE.SUCCESS:
        toast.success(message, config);
        break;
      case RESPONSE_TYPE.ERROR:
        toast.error(message, config);
        break;
      case RESPONSE_TYPE.WARNING:
        toast.warning(message, config);
        break;
      case RESPONSE_TYPE.INFO:
        toast.info(message, config);
        break;
      default:
        break;
    }
  };
};

export const handleLoadingState = () => {
  const transate = inject(TranslateService);

  return (isLoading: boolean, message?: string) => {
    toast.loading(transate.instant(message || 'Loading...'));
    if (!isLoading) {
      toast.dismiss();
      return;
    }
  };
};
